import React from 'react';

const AllOutlets = ({className = ""}) => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <rect width="40" height="40" rx="20" fill="#ECEBFC" />
    <path
      d="M28.5 19.3V15.04C28.5 11.01 27.56 10 23.78 10H16.22C12.44 10 11.5 11.01 11.5 15.04V26.3C11.5 28.96 12.96 29.59 14.73 27.69L14.74 27.68C15.56 26.81 16.81 26.88 17.52 27.83L18.53 29.18"
      stroke="#928FEF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M16 15H24" stroke="#928FEF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M17 19H23" stroke="#928FEF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M26.211 22.7703L22.671 26.3103C22.531 26.4503 22.401 26.7103 22.371 26.9003L22.181 28.2503C22.111 28.7403 22.451 29.0803 22.941 29.0103L24.291 28.8203C24.481 28.7903 24.751 28.6603 24.881 28.5203L28.421 24.9803C29.031 24.3703 29.321 23.6603 28.421 22.7603C27.531 21.8703 26.821 22.1603 26.211 22.7703Z"
      stroke="#928FEF"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.6992 23.2803C25.9992 24.3603 26.8392 25.2003 27.9192 25.5003"
      stroke="#928FEF"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const AllItems = ({className = ""}) => (
  <svg
  width="40"
  height="40"
  viewBox="0 0 40 40"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  className={className}
>
  <rect width="40" height="40" rx="20" fill="#F9E7F2" />
  <path
    d="M20 13.5601H30"
    stroke="#FF9BDF"
    strokeWidth="1.5"
    strokeMiterlimit="10"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M22.22 10H27.78C29.56 10 30 10.44 30 12.2V16.31C30 18.07 29.56 18.51 27.78 18.51H22.22C20.44 18.51 20 18.07 20 16.31V12.2C20 10.44 20.44 10 22.22 10Z"
    stroke="#FF9BDF"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M10 25.0601H20"
    stroke="#FF9BDF"
    strokeWidth="1.5"
    strokeMiterlimit="10"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M12.22 21.5H17.78C19.56 21.5 20 21.94 20 23.7V27.81C20 29.57 19.56 30.01 17.78 30.01H12.22C10.44 30.01 10 29.57 10 27.81V23.7C10 21.94 10.44 21.5 12.22 21.5Z"
    stroke="#FF9BDF"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M30 23C30 26.87 26.87 30 23 30L24.05 28.25"
    stroke="#FF9BDF"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M10 17C10 13.13 13.13 10 17 10L15.95 11.75"
    stroke="#FF9BDF"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>
);

const ChatBubbleIcon = ({ className = "" }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect width="40" height="40" rx="20" fill="#D4F6E3" />
    <path
      d="M28.5 19.3V15.04C28.5 11.01 27.56 10 23.78 10H16.22C12.44 10 11.5 11.01 11.5 15.04V26.3C11.5 28.96 12.96 29.59 14.73 27.69L14.74 27.68C15.56 26.81 16.81 26.88 17.52 27.83L18.53 29.18"
      stroke="#56E196"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.2 29.4C27.9673 29.4 29.4 27.9673 29.4 26.2C29.4 24.4327 27.9673 23 26.2 23C24.4327 23 23 24.4327 23 26.2C23 27.9673 24.4327 29.4 26.2 29.4Z"
      stroke="#56E196"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30 30L29 29"
      stroke="#56E196"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 15H24"
      stroke="#56E196"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 19H23"
      stroke="#56E196"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const VoucherIcon = ({ className = "" }) => (
  <svg
    width="28"
    height="22"
    viewBox="0 0 28 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.677 20.3371L16.6848 17.6666C16.6848 16.9302 17.2832 16.3333 18.0214 16.3333C18.7596 16.3333 19.3581 16.9302 19.3581 17.6666V20.3019C19.3581 20.9439 19.3581 21.265 19.5639 21.4618C19.7698 21.6587 20.0848 21.6453 20.7147 21.6186C23.1987 21.5135 24.7247 21.1775 25.8004 20.1045C26.8786 19.0289 27.2145 17.5021 27.3191 15.014C27.3398 14.5205 27.3502 14.2738 27.258 14.1092C27.1659 13.9446 26.7981 13.7392 26.0624 13.3284C25.2454 12.8721 24.6931 12.0004 24.6931 10.9999C24.6931 9.99949 25.2454 9.12773 26.0624 8.67146C26.7981 8.26063 27.1659 8.05522 27.258 7.89062C27.3502 7.72602 27.3398 7.47931 27.3191 6.98588C27.2145 4.49778 26.8786 2.97089 25.8004 1.89535C24.6301 0.727971 22.9268 0.432992 20.0369 0.358455C19.6641 0.348839 19.3581 0.649491 19.3581 1.02149V4.33325C19.3581 5.06963 18.7596 5.66659 18.0214 5.66659C17.2832 5.66659 16.6848 5.06963 16.6848 4.33325L16.6751 0.997987C16.674 0.630552 16.3751 0.333252 16.0068 0.333252H11.3265C6.28568 0.333252 3.76526 0.333252 2.19927 1.89535C1.12105 2.97089 0.785212 4.49778 0.680607 6.98588C0.659862 7.47931 0.64949 7.72602 0.741629 7.89062C0.833769 8.05522 1.20161 8.26063 1.93728 8.67146C2.75431 9.12773 3.3066 9.99949 3.3066 10.9999C3.3066 12.0004 2.75431 12.8721 1.93728 13.3284C1.20161 13.7392 0.833768 13.9446 0.741629 14.1092C0.64949 14.2738 0.659862 14.5205 0.680607 15.014C0.785212 17.5021 1.12105 19.0289 2.19927 20.1045C3.76526 21.6666 6.28568 21.6666 11.3265 21.6666H15.3404C15.9688 21.6666 16.283 21.6666 16.4786 21.472C16.6743 21.2774 16.6752 20.964 16.677 20.3371ZM19.3581 12.3333V9.66659C19.3581 8.93021 18.7596 8.33325 18.0214 8.33325C17.2832 8.33325 16.6848 8.93021 16.6848 9.66659V12.3333C16.6848 13.0696 17.2832 13.6666 18.0214 13.6666C18.7596 13.6666 19.3581 13.0696 19.3581 12.3333Z"
      fill="#FE5900"
    />
  </svg>
);


export { AllOutlets, AllItems, ChatBubbleIcon, VoucherIcon };
